import { forwardRef } from "react";
import { TbChevronDown } from "react-icons/tb";
import { useLanguage } from "../../context/LanguageContext";
import PropTypes from "prop-types";

const InputSelect = forwardRef(
  (
    { label, options, value, onChange, error, className = "", ...props },
    ref
  ) => {
    const { copy } = useLanguage();

    return (
      <div className={`relative flex flex-col gap-1 ${className}`}>
        {label && (
          <label className="text-base md:text-sm font-medium">{label}</label>
        )}

        <div className="relative">
          <select
            ref={ref}
            value={value}
            onChange={onChange}
            className={`w-full text-base md:text-sm px-4 pr-10 py-1.5 input-base bg-white border rounded-md card-base-border cursor-pointer appearance-none focus:outline-none transition ${
              error
                ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                : "focus:ring-blue-500 focus:border-blue-500"
            }`}
            {...props}
          >
            <option value="">{copy.addgoal.form.label_milestone_select}</option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {/* Custom Arrow Icon */}
          <div className="absolute top-0 right-0 flex items-center justify-center h-full px-4 pointer-events-none">
            <TbChevronDown />
          </div>
        </div>

        {error && <p className="text-xs !text-red-500 mt-1">{error}</p>}
      </div>
    );
  }
);

InputSelect.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  details: PropTypes.string,
  options: PropTypes.array,
  className: PropTypes.string,
};

InputSelect.displayName = "InputSelect";

export default InputSelect;
